module.exports = __webpack_public_path__ + "img/744.afe4e588.jpg";